module.exports = __webpack_public_path__ + "static/sparkles-d19624d5f5e5ef1aa541960445983b38.gif";